import React, { memo } from 'react';

const StartSpaceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.000003831062258541351, -3.5762786865234375e-7, 81.25006103515625, 64.36005401611328"
  >
    <path d="M40.62 2A13.92 13.92 0 1 1 26.7 15.92 13.936 13.936 0 0 1 40.62 2m0-2a15.92 15.92 0 1 0 15.92 15.92A15.923 15.923 0 0 0 40.62 0z" />
    <path d="M72.14 64.36a1 1 0 0 1-1-1 30.52 30.52 0 1 0-61.04 0 1 1 0 0 1-2 0 32.52 32.52 0 1 1 65.04 0 .99.99 0 0 1-1 1z" />
    <path d="M65.9 16.87a6.53 6.53 0 1 1-6.53 6.53 6.538 6.538 0 0 1 6.53-6.53m0-2a8.53 8.53 0 1 0 8.53 8.53 8.531 8.531 0 0 0-8.53-8.53z" />
    <path d="M80.25 49.82a1 1 0 0 1-1-1 15.893 15.893 0 0 0-24.77-13.18 1.001 1.001 0 1 1-1.12-1.66 17.885 17.885 0 0 1 27.89 14.83 1 1 0 0 1-1 1.01z" />
    <path d="M15.34 16.87a6.53 6.53 0 1 1-6.53 6.53 6.538 6.538 0 0 1 6.53-6.53m0-2a8.53 8.53 0 1 0 8.53 8.53 8.531 8.531 0 0 0-8.53-8.53z" />
    <path d="M1 49.82a1 1 0 0 1-1-1 17.878 17.878 0 0 1 27.88-14.83 1.001 1.001 0 1 1-1.12 1.66A15.886 15.886 0 0 0 2 48.82a1 1 0 0 1-1 1z" />
  </svg>
);

export default memo(StartSpaceIcon);
